import { toast, ToastBar, Toaster } from 'react-hot-toast';
import { IoIosClose } from 'react-icons/io';

/**
 * @description ToasterNotifications component that displays toast notifications using react-hot-toast.
 * Provides dismissible notifications with custom styling positioned at bottom-left.
 *
 * @SADtrace SAD-003-1.1, SAD-003-2.1, SAD-003-3.1, SAD-003-4.1, SAD-003-5.1, SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @returns {JSX.Element} The ToasterNotifications component
 */
const ToasterNotifications = () => {
  return (
    <Toaster
      position="bottom-left"
      toastOptions={{
        style: {
          border: '1px solid #292E38',
          padding: '16px',
          color: '#292E38',
          borderRadius: '3px',
        },
        duration: 4000,
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button
                  data-testid="toast_close_btn"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toast.remove(t.id)}
                >
                  <IoIosClose size={24} />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
};

export default ToasterNotifications;
